import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, CandlestickChart, Star, Globe, ScanSearch,
  Boxes, ArrowLeftRight, LineChart, Bell, Newspaper, Settings,
} from "lucide-react";

const LOGO = "https://static.prod-images.emergentagent.com/jobs/cfee5ed3-952d-485c-8c92-561a2e6c4885/images/e72bac7532b37f64eee874182a2cf6172ae29f3d2bb3ea1d3f339c87f77fd161.jpeg";

export const NAV = [
  { id: "dashboard", to: "/dashboard", icon: LayoutDashboard, label: "Dashboard", title: "Overview" },
  { id: "chart", to: "/chart", icon: CandlestickChart, label: "Chart", title: "Chart Engine" },
  { id: "watchlist", to: "/watchlist", icon: Star, label: "Watchlist", title: "Watchlist" },
  { id: "markets", to: "/markets", icon: Globe, label: "Markets", title: "Markets" },
  { id: "scanner", to: "/scanner", icon: ScanSearch, label: "Scanner", title: "R.I.O Scanner" },
  { id: "journal", to: "/journal", icon: Boxes, label: "Journal", title: "Trade Journal" },
  { id: "demo-trade", to: "/demo-trade", icon: ArrowLeftRight, label: "Demo Trade", title: "Deriv Demo Trading" },
  { id: "score-lab", to: "/score-lab", icon: LineChart, label: "Score Lab", title: "Score Lab" },
  { id: "alerts", to: "/alerts", icon: Bell, label: "Alerts", title: "Alerts" },
  { id: "news", to: "/news", icon: Newspaper, label: "News", title: "Market News" },
  { id: "settings", to: "/settings", icon: Settings, label: "Settings", title: "Settings" },
];

// Data-aware sidebar: badges are REAL counters (unread alerts, open demo contracts, scanner matches).
export default function Sidebar({ badges = {}, className = "" }) {
  return (
    <aside className={`w-[76px] shrink-0 flex-col items-center border-r border-border bg-panel py-3 ${className || "flex"}`} data-testid="sidebar">
      <nav className="flex flex-col items-center gap-1 flex-1">
        {NAV.map((n) => {
          const Icon = n.icon;
          const b = badges[n.id];
          return (
            <NavLink key={n.id} to={n.to} data-testid={`nav-${n.id}`} title={n.title}
              className={({ isActive }) => `group relative w-[60px] py-2 rounded-lg flex flex-col items-center gap-1 transition-colors ${isActive ? "bg-primary/15 text-primary nav-active" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}>
              {({ isActive }) => (<>
                {isActive && <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-0.5 rounded-r bg-primary" />}
                <Icon className="h-[18px] w-[18px]" />
                <span className="text-[9px] font-medium">{n.label}</span>
                {b?.count > 0 && (
                  <span data-testid={`nav-badge-${n.id}`} className={`absolute top-1 right-1.5 min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold flex items-center justify-center ${b.tone === "sell" ? "bg-sell text-white" : b.tone === "buy" ? "bg-buy text-black" : "bg-primary text-primary-foreground"}`}>{b.count > 99 ? "99+" : b.count}</span>
                )}
              </>)}
            </NavLink>
          );
        })}
      </nav>
      <div className="mt-2 flex flex-col items-center">
        <div className="rounded-xl overflow-hidden border border-primary/30 glow-amber w-[60px]">
          <img src={LOGO} alt="Fela R.I.O bull" className="w-full h-auto object-cover" />
        </div>
        <div className="mt-2 text-center leading-tight">
          <p className="text-[8px] font-bold text-primary tracking-wide">DISCIPLINE</p>
          <p className="text-[8px] font-bold text-primary tracking-wide">EXECUTION</p>
          <p className="text-[8px] font-bold text-primary tracking-wide">FREEDOM</p>
        </div>
      </div>
    </aside>
  );
}
